module.exports = __webpack_public_path__ + "e31082e8d4f9c164d15bcee440778333.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1160
// module chunks = 0